import React, { useEffect, useState } from "react";
import {
    ApiQuery,
    QueryResponse,
    SortDirections,
} from "~/modules/filters/types";
import {
    TokenHolder,
    TokenHoldersColumns,
} from "~/modules/token_holders/types";
import { api } from "~/utils/api";
import { deobfuscate } from "~/utils/obfuscate";

// // // //

export function TokenHoldersFetcher(props: {
    query: ApiQuery;
    children: (childProps: {
        data: QueryResponse<TokenHolder>;
        loading: boolean;
    }) => React.ReactNode;
}) {
    const { query, children } = props;

    // Store the last response for a more refined loading transition
    const [lastResponse, setLastResponse] = useState<
        QueryResponse<TokenHolder>
    >({
        sort: {
            direction: SortDirections.desc,
            field: TokenHoldersColumns.holdingTokenValueUSD,
        },
        pagination: {
            page: 1,
            perPage: 100,
            resultCount: 101,
            pageCount: 2,
        },
        results: [],
    });

    const req = api.tokenHolders.query.useQuery(
        { query },
        {
            refetchOnWindowFocus: false,
            staleTime: Infinity,
            select: (data) => deobfuscate(data as string),
        },
    );

    // // // //

    // Update the lastResponse state when data updates
    useEffect(() => {
        if (req.data) {
            setLastResponse(req.data);
        }
    }, [req.data]);

    return (
        <>
            {children({
                loading: req.isLoading,
                data: lastResponse,
            })}
        </>
    );
}
